/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Empty_EventInputs */



/**
* | output |
* | --- |
* | "Empty event" |
*
* @param {Video_Export_Preview_Empty_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_empty_event = /** @type {((inputs?: Video_Export_Preview_Empty_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Empty_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Evenement vide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Leeres Ereignis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evento vuoto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пустое событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento vacío")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("空事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("空のイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खाली घटना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento vazio")
	return /** @type {LocalizedString} */ ("Empty event")
});